var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgEl4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 29,
    viewBox: "0 0 20 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5754 12.5125C16.9179 11.7729 15.2604 11.0334 13.5512 10.2411C12.6706 9.02614 12.1527 7.65274 11.9973 6.17369C11.6347 4.48334 11.5311 2.84582 11.4793 1.10265C11.3757 -0.587688 8.94133 -0.217922 8.94133 1.4196C8.99312 7.1245 5.88536 11.7729 0.757547 14.0443C-0.589152 14.6254 0.0324017 16.6327 1.27551 16.527C1.4309 16.6327 1.53449 16.6855 1.74167 16.7383C5.93716 17.6363 8.47516 20.9642 8.63055 24.9259C8.52695 25.7711 8.42337 26.6163 8.42337 27.5143C8.42337 27.6199 8.42337 27.7255 8.42337 27.884C8.42337 29.4159 10.7024 29.3102 10.9614 27.9368C11.1686 26.8804 11.2204 25.8767 11.2204 24.8731C11.9973 20.3831 14.8461 16.844 19.1969 14.9952C20.5954 14.4141 20.0257 12.4068 18.5754 12.5125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgEl4);
export default __webpack_public_path__ + "static/media/bg-el-4.18f485a0d74699e0369702d445b5c54c.svg";
export { ForwardRef as ReactComponent };